import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { SparkoLogo } from "../../components/SparkoLogo";
import { Icon } from "../../components/common";

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password updated. Please sign in.");
      setTimeout(() => nav("/admin/login"), 1500);
    } catch (e) {
      setErr(e.response?.data?.detail || "Could not reset password");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-navy p-6 grain">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="mb-8 flex justify-center"><SparkoLogo dark={false} size={30} tagline /></div>
        <h1 className="font-display text-3xl text-white text-center">Set a new password</h1>
        {!token ? (
          <p className="mt-4 text-center text-sm text-red-400" data-testid="reset-invalid">This reset link is missing its token. Please request a new link from the login page.</p>
        ) : done ? (
          <p className="mt-4 text-center text-sm text-blue" data-testid="reset-success">Your password has been updated. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-password-form">
            <div>
              <label className="text-sm text-white/70">New password</label>
              <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password"
                className="mt-1 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-white placeholder-white/30 outline-none focus:border-blue" placeholder="At least 8 characters" />
            </div>
            <div>
              <label className="text-sm text-white/70">Confirm new password</label>
              <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm"
                className="mt-1 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-white placeholder-white/30 outline-none focus:border-blue" placeholder="••••••••" />
            </div>
            {err && <p className="text-sm text-red-400" data-testid="reset-error">{err}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-blue px-6 py-3.5 font-semibold text-white hover:bg-[#0052FF] disabled:opacity-60">
              {loading ? <Icon name="Loader2" size={18} className="animate-spin" /> : <Icon name="ShieldCheck" size={18} />} Update password
            </button>
          </form>
        )}
        <a href="/admin/login" className="mt-6 inline-flex w-full items-center justify-center gap-1.5 text-sm text-white/40 hover:text-white"><Icon name="ArrowLeft" size={14} /> Back to sign in</a>
      </motion.div>
    </div>
  );
}
